import { defineComponent } from 'vue-demi';
import { openBlock, createElementBlock, normalizeClass, renderSlot } from 'vue';
import { s as styleInject } from './style-inject.es-4c6f2515.js';

var script = defineComponent({
  name: 'OrOverlay',
  props: {
    /** You can use this prop instead of v-if if you want to preserve content state */
    isActive: {
      type: Boolean,
      default: false
    },
    /** Attach overlay to browser window rather then nearest relative container */
    isPage: {
      type: Boolean,
      default: false
    },
    /** Show overlay without default background color */
    isWithoutBackground: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    states() {
      return {
        active: this.isActive,
        page: this.isPage,
        'without-background': this.isWithoutBackground
      };
    }
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["or-overlay", _ctx.states])
  }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */);
}

var css_248z = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-34f88318 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-34f88318 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-overlay[data-v-34f88318] {\n  display: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 25;\n}\n.or-overlay[data-v-34f88318]:not(.without-background) {\n  background-color: rgba(30, 35, 43, 0.8);\n}\n.or-overlay.active[data-v-34f88318] {\n  display: flex;\n}\n.or-overlay.page[data-v-34f88318] {\n  position: fixed;\n  height: 100vh;\n  width: 100vw;\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-34f88318";
script.__file = "src/components/or-overlay/OrOverlay.vue";

export { script as s };
